// A magic-link token is single-use, and the tokenised URL stays reachable after it is redeemed, so
// re-mounting the magic-link route must not replay it. Module scope rather than a ref, so the claim
// survives that re-mount. The claim is taken before the request so a concurrent double submit is
// covered too, and released again when the request never reached the server, which leaves a link the
// server never saw still usable.
const attemptedTokens = new Set<string>();

export const claimTokenRedemption = (token: string): boolean => {
  if (attemptedTokens.has(token)) {
    return false;
  }

  attemptedTokens.add(token);
  return true;
};

export const releaseTokenRedemption = (token: string): void => {
  attemptedTokens.delete(token);
};

// Column API errors always carry a code; a reCAPTCHA or transport failure does not.
export const wasRejectedByServer = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && 'code' in error;
